import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ItemDescriptionComponent } from '@modules/common/components/item-description/item-description.component';
import { SharedBaseComponent } from '@modules/common/components/shared-base/shared-base.component';
import { StchHighlightTextDirective } from '@modules/common/directives/stch-highlight-text.directive';
import { DateFormatPipe } from '@modules/common/pipes/date-format.pipe';
import { FilesAppContextDirective } from '@modules/files/directives/app-files-app-context.directive';
import { FilesService } from '@modules/files/services/files.service';
import { File } from '@modules/files/types/file';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { SharedKnotsComponent } from '@modules/knots/components/shared-knots/shared-knots.component';
import { SharedSignupCtaComponent } from '@modules/common/components/shared-signup-cta/shared-signup-cta.component';
import { SharedTagsComponent } from '@modules/tags/components/shared-tags/shared-tags.component';
import { StitchType } from '@sharedlib/common/types/StitchType';
import { FilePreviewComponent } from '../file-preview/file-preview.component';
import { hasFileLink, isValidFileLink } from '@modules/files/types/file-link';

@Component({
  selector: 'stch-file-shared',
  templateUrl: './file-shared.component.html',
  styleUrls: ['../../../common/components/shared-base/shared-base.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FilesAppContextDirective,
    IconComponent,
    DateFormatPipe,
    FilePreviewComponent,
    SharedTagsComponent,
    SharedKnotsComponent,
    SharedSignupCtaComponent,
    StchHighlightTextDirective,
    ItemDescriptionComponent,
  ],
})
export class FileSharedComponent extends SharedBaseComponent<File> {
  protected readonly hasFileLink = hasFileLink;
  protected readonly isValidFileLink = isValidFileLink;
  protected readonly stitchType = StitchType.FILE;
  private readonly filesService: FilesService = inject(FilesService);
  private readonly destroyRef = inject(DestroyRef);

  protected get file(): File {
    return this.stitchItem?.();
  }

  protected download(): void {
    if (hasFileLink(this.file)) return;
    // sharedUrl might be expired at a time download is requested, so we need to load file to get fresh shared url
    this.loadSharedItem()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((file) => {
        this.filesService.download(file);
      });
  }
}
